import { useEffect, useState } from 'react'
import { useTeamsSDK } from 'use-teams-sdk'

type Theme = 'light' | 'dark' | 'contrast' | 'default'

export function useTeamsTheme(): Theme {
  const [theme, setTheme] = useState<Theme>('default')
  const teamsSDKPromise = useTeamsSDK()

  useEffect(() => {
    // Check system preference first
    const prefersDark =
      window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    const defaultTheme = prefersDark ? 'dark' : 'light'

    // Set initial theme based on system preference
    setTheme(defaultTheme)

    // Listen for system preference changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = (e: MediaQueryListEvent) => {
      setTheme(e.matches ? 'dark' : 'light')
    }

    mediaQuery.addEventListener('change', handleChange)

    // Try to get Teams theme, which will override system preference if available
    async function detectTeamsTheme() {
      try {
        const teamsSDK = await teamsSDKPromise
        if (teamsSDK) {
          const context = await teamsSDK.app.getContext()
          if (context.app?.theme) {
            setTheme(context.app.theme as Theme)
          }
        }
      } catch (error) {
        console.error('Failed to get Teams theme:', error)
      }
    }

    detectTeamsTheme()

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [teamsSDKPromise])

  return theme
}
